import React, { memo } from "react";
import styles from "./DraftBanner.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const DraftBanner: React.FC = () => (
  <div className={styles.draftBanner}>
    <div className={styles.draftBannerContent}>
      <span className={styles.draftBannerText}>This is a draft page (only for preview)</span>
    </div>
  </div>
);

export default wrapperHOC(memo(DraftBanner), {
  componentName: "DraftBanner-Blog",
  showForChina: true,
});
